import * as R from 'ramda'
import {
    FETCH_TAGS_SUCCESS,
    /*ADD_LINE_SUCCESS,
    FETCH_ADDED_LINE_SUCCESS*/
} from '../actionTypes'

const InitialState = {};

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case FETCH_TAGS_SUCCESS:
            return R.merge(state,payload)
        /*case ADD_LINE_SUCCESS:
            return R.append(payload, state)
        case FETCH_ADDED_LINE_SUCCESS:
            return R.merge(state,payload)*/

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/tags.js